define('lq/events/actions/stopImpersonatingCommand',[
    'lq',
    'lq/events/actions/eventAction'
], function(lq, EventAction) {
    'use strict';

    function StopImpersonatingCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    };

    EventAction.extend(StopImpersonatingCommand, EventAction);

    StopImpersonatingCommand.typeName = 'StopImpersonatingCommand';

    StopImpersonatingCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    StopImpersonatingCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'StopImpersonating',
            command: this.eventData.command
        };
    };

    StopImpersonatingCommand.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;
        if (eventActionResponse.status === 'success')
            // the page is back to the impersonator: take over its token before anything else is sent
            this.refreshCsrfTokenForNewUser(function () {
                self.triggerEventIfEnabledAndContinue('impersonationStopped', continuation);
            });
        else
            this.triggerEventIfEnabledAndContinue('impersonationStopFailed', continuation, eventActionResponse.description);
    };

    return StopImpersonatingCommand;
});

